<body>

    <div class="main_content" [ngClass]="{ 'collapsed': isCollapsed }">
        <app-sidebar class="sideBar"></app-sidebar>
    </div>

    <main class="landing-main">
        <ng-container *ngIf="reportsActive">
            <app-meal-order-summary *ngIf="activeView === 'mealOrderSummary'" [style.width]="containerWidth"
                [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-meal-order-summary>
        </ng-container>

        <app-mess-inventory *ngIf="activeView === 'messDetailsInventory'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-mess-inventory>

        <app-meal-request *ngIf="activeView === 'mealRequest'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }">
        </app-meal-request>

        <app-mess-do-details *ngIf="activeView === 'messDoDetails'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-mess-do-details>

        <app-mess-do-detail-view *ngIf="activeView === 'messDoDetailView'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-mess-do-detail-view>

        <app-admin-dashboard *ngIf="activeView === 'adminDashboardReports'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-admin-dashboard>

        <app-admin-division-report *ngIf="activeView === 'adminDivisionReport'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-admin-division-report>

        <app-admin-mess-inventory *ngIf="activeView === 'adminMessInventory'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-admin-mess-inventory>

        <app-add-new-menu-item *ngIf="activeView === 'addNewMenuItem'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-add-new-menu-item>

        <app-mess-closed-details *ngIf="activeView === 'messClosedDetails'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-mess-closed-details>

        <app-mess-excel *ngIf="activeView === 'messExcelDetails'" [style.width]="containerWidth"
            [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-mess-excel>

    </main>

</body>


<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>